import React, { useCallback } from 'react';
import dynamic from 'next/dynamic';
import { useIdleCallback } from '@shopify/react-idle';
import { fetchProductPage } from '@fh-components/fh-js-api-core/store/slices/productSlice';
import { productErrorSelector } from '@/store';
import { handleError } from '@/lib/handleError';
import { Loader } from '@/components';
import ecommerce from '@/seo/Ecommerce';

const ProductPage = dynamic(() => import('../../layouts/ProductPage'), {
	loading: () => <Loader />,
});

export default function NextProductPage() {
	const setPageType = useCallback(() => {
		ecommerce.setPageType(ecommerce.PAGE_TYPES.PRODUCT);
	}, []);

	useIdleCallback(setPageType);

	return <ProductPage />;
}

NextProductPage.getInitialProps = async ({ query, reduxStore }) => {
	const { productId } = query;

	await reduxStore.dispatch(fetchProductPage({ slug: productId }));

	const error = productErrorSelector(reduxStore.getState());

	handleError(error);

	return {};
};
